module.exports = __webpack_public_path__ + "static/media/payoneer.0c062794.png";